import {css, html} from 'lit';
import {customElement, property} from 'lit/decorators';
import {GridColumn} from '@webs/components-library/grid-column';
import {typographyStyles} from '@webs/components-library/theming';


@customElement('webs-card-career')
export class CardCareer extends GridColumn {
  private internalCareer: string;
  static styles = [
    typographyStyles,
    ...GridColumn.styles,
    css`
      :host {
          --default-paragraph-size: .7rem;

      }

      .m-card-career {
        border: 1px solid var(--color-grey);
        border-radius: .8rem;
        display: block;
        height: 100%;
        position: relative;
        text-decoration: none;
      }

      .m-card-career__wrapper {
        background: var(--color-white);
        border-radius: .73rem;
        display: flex;
        flex-flow: column-reverse;
        height: calc(100% - 2.4rem);
        justify-content: space-between;
        padding: 1.2rem 1.6rem;
        transition: all .3s;
      }

      .m-card-career::before {
        background: linear-gradient(169.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%);
        border-radius: .8rem;
        content: '';
        height: calc(100% + 4px);
        left: -2px;
        opacity: 0;
        position: absolute;
        top: -2px;
        transition: opacity .1s linear;
        width: calc(100% + 4px);
        z-index: -2;
      }

      .m-card-career:hover,
      .m-card-career.active {
        border-color: transparent;
      }

      .m-card-career:hover::before,
      .m-card-career.active::before {
        opacity: 1;
      }

      .m-card-career__left-side--career {
        margin-bottom:.8rem;
      }

      .m-card-career__left-side--tag {
        background: var(--color-dark-grey);
        color: var(--color-white);
        border-radius: 1rem;
        padding: 6px 12px;
        display: inline-block;
        font-family: var(--font-family-alternative);
        font-size: 0.5rem;
        line-height: 1.3;
        text-transform: uppercase;
      }

      .m-card-career__right-side {
        font-family: var(--font-family-alternative);
        font-size: 0.7rem;
        line-height: 1.3;
        text-align: left;
        display: flex;
        font-feature-settings: 'salt' on, 'liga' off;
        color: var(--color-grey);
        margin: 0 -.25rem 1rem;
      }

      .m-card-career__right-side p {
        font-weight: var(--font-weight-base);
        margin: 0 .25rem;
      }

      @media only screen and (min-width: 576px){
        .m-card-career__wrapper {
          justify-content: space-between;
          flex-direction: row;
        }

        .m-card-career__left-side,
        .m-card-career__right-side {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .m-card-career__right-side {
          align-items: flex-end;
          margin: 0 0 0 1.2rem;
          padding: .175rem 0;
        }
      }

      @media only screen and (min-width: 992px) {
        :host {
          --default-paragraph-size: .7rem;
          a {
            font-weight: var(--font-weight-base);
          }
        }
      }
    `,
  ];
  @property()
  set career(value: string) {
    const oldValue = this.internalCareer;
    this.internalCareer = value;
    this.requestUpdate('career', oldValue);
  }

  get career(): string {
    return this.internalCareer;
  }

  @property()
  city: string;

  @property()
  type: string;

  @property()
  tag: string;

  @property()
  href: string;

  protected render(): unknown {
    return this.href ?
      html`<a href="${this.href}" class="m-card-career">
        <div class="m-card-career__wrapper">
          <div class="m-card-career__left-side">
            ${this.career ? html`<h4 class="m-card-career__left-side--career">${this.career}</h4>` : html``}
            ${this.tag ? html`
              <div class="m-card-career__left-side--tag">${this.tag}</div>` : html``}
          </div>
          <div class="m-card-career__right-side">
            ${this.city ? html`<p class="m-card-career__right-side--city">${this.city}</p>` : html``}
            ${this.type ? html`<p class="m-card-career__right-side--type">${this.type}</p>` : html``}
          </div>
        </div>
      </a>` :
      html`
        <div class="m-card-career">
          <div class="m-card-career__wrapper">
            <div class="m-card-career__left-side">
              ${this.career ? html`<h4 class="m-card-career__left-side--career">${this.career}</h4>` : html``}
              ${this.tag ? html`
                <div class="m-card-career__left-side--tag">${this.tag}</div>` : html``}
            </div>
            <div class="m-card-career__right-side">
              ${this.city ? html`<p class="m-card-career__right-side--city">${this.city}</p>` : html``}
              ${this.type ? html`<p class="m-card-career__right-side--type">${this.type}</p>` : html``}
            </div>
          </div>
        </div>`
  }
}
